export class UpdateSectorIdUseCase {
  constructor(repository, sectorHasSoilrepository, sectorHasFarmrepository) {
    this.repository = repository
    this.sectorHasSoilRepository = sectorHasSoilrepository
    this.sectorHasFarmRepository = sectorHasFarmrepository
  }
  async execute(sector) {
    const { ID_SECTOR, ID_FARM, ID_SOIL } = sector
    const resp = await this.repository.update(sector)


    const data = await this.repository.showBySectorId(ID_SECTOR)
    if (data && data[0].length) {
      //Lembrando que esse ID não é o ID do setor e sim ID tabela CAD_SECTOR de CROP
      await this.sectorHasFarmRepository.updateByIdSector(data[0][0].ID, ID_FARM)
      await this.sectorHasSoilRepository.updateByIdSector(data[0][0].ID, ID_SOIL)
    }

    return resp
  }
}
